import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export default function({ children, recaptchaKey, captchaProvider, hcaptchaKey, ...props }) {
  console.log('Security Provider', { recaptchaKey, captchaProvider, hcaptchaKey });

  if (captchaProvider === 'hcaptcha') {
    return (
        <>{children}</>
    )
  }

  return recaptchaKey ? (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaKey}
      useRecaptchaNet={true}
      useEnterprise={true}
    >
      {children}
    </GoogleReCaptchaProvider>
  ) : (
    <>{children}</>
  );
}
